import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgEmailSent() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="email-sent" /></AuthShell>;
}

export default AuthCoverBgEmailSent;
